import { GVOpportunity } from 'models/GoldVision/GVOpportunities';
import { ActionType, getType } from 'typesafe-actions';

import * as gvOpportunitiesActions from './actions';

export type GVOpportunitiesActionType = ActionType<
  typeof gvOpportunitiesActions
>;

export interface GVOpportunitiesState {
  gvOpportunities: GVOpportunity[];
  loading: boolean;
  totalRowCount: number;
}

const initialState: GVOpportunitiesState = {
  gvOpportunities: [],
  loading: false,
  totalRowCount: 0,
};

const gvOpportunitiesReducer = (
  state: GVOpportunitiesState = initialState,
  action: GVOpportunitiesActionType,
): GVOpportunitiesState => {
  switch (action.type) {
    case getType(gvOpportunitiesActions.getAllGVOpportunities.request):
      return {
        ...state,
        loading: true,
      };

    case getType(gvOpportunitiesActions.getAllGVOpportunities.success):
      return {
        ...state,
        gvOpportunities: action.payload.data.data,
        totalRowCount: action.payload.data.totalRowCount,
        loading: false,
      };

    case getType(gvOpportunitiesActions.getAllGVOpportunities.failure):
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default gvOpportunitiesReducer;
